// extracted by mini-css-extract-plugin
module.exports = {"loading":"LoadingElement_loading__2aWRZ"};